import { createAction, props } from '@ngrx/store';

export const LoadFilterFields = createAction('[FilterFields] Load Filter Fields');
export const LoadFilterFieldsSuccess = createAction(
  '[FilterFields] Load Filter Fields Success',
  props<{ fields: { [key: string]: { id: number; name: string }[] } }>()
);
export const LoadFilterFieldsFail = createAction('[FilterFields] Load Filter Fields Fail', props<{ error: any }>());
